import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';

document.querySelectorAll('.highlighted_categories')?.forEach((element) => {
    const paginationEl = element.parentElement.querySelector('[data-product-rail-pagination]');
    const nextEl = element.parentElement.querySelector('.highlighted_categories-navigation-right');
    const prevEl = element.parentElement.querySelector('.highlighted_categories-navigation-left');

    return new Swiper(element, {
        modules: [Navigation, Pagination],
        slidesPerView: 'auto',
        spaceBetween: 12,
        pagination: {
            el: paginationEl,
            clickable: true,
        },
        navigation: {
            nextEl,
            prevEl,
        },
    });
});
